import axios from '../../axios';
// 调拨单列表
export const getStkMovePage = data => {
  return axios({
    url: '/api/sys/stk/getStkMovePage',
    method: 'post',
    data
  })
};
// 调拨单总合计
export const getStkMoveSum = data => {
  return axios({
    url: '/api/sys/stk/getStkMoveSum',
    method: 'post',
    data
  })
};
// 调拨单保存
export const saveStkMove = data => {
  return axios({
    url: '/api/sys/stk/saveStkMove',
    method: 'post',
    data
  })
};

// 调拨单修改
export const updateStkMove = data => {
  return axios({
    url: '/api/sys/stk/updateStkMove',
    method: 'post',
    data
  })
};

// 调拨单删除
export const deleteStkMoves = data => {
  return axios({
    url: '/api/sys/stk/deleteStkMoves',
    method: 'post',
    data
  })
};
// 调拨单作废
export const cancelStkMoves = data => {
  return axios({
    url: '/api/sys/stk/cancelStkMoves',
    method: 'post',
    data
  })
};
// 调拨单审核 auditStatus 1已审核 0未审核/反
export const auditStkMoves = data => {
  return axios({
    url: '/api/sys/stk/auditStkMoves',
    method: 'post',
    data
  })
};

// 调拨单明细列表
export const getStkMoveEntryPage = data => {
  return axios({
    url: '/api/sys/stk/getStkMoveEntryPage',
    method: 'post',
    data
  })
};
// 调拨单明细保存
export const saveStkMoveEntry = data => {
  return axios({
    url: '/api/sys/stk/saveStkMoveEntry',
    method: 'post',
    data
  })
};

// 调拨单明细修改
export const updateStkMoveEntry = data => {
  return axios({
    url: '/api/sys/stk/updateStkMoveEntry',
    method: 'post',
    data
  })
};

// 调拨单明细删除
export const deleteStkMoveEntrys = data => {
  return axios({
    url: '/api/sys/stk/deleteStkMoveEntrys',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/stk/StkInAllocation.js